module.exports = __webpack_public_path__ + "img/Butterfly_00408.9312fa3b.png";